import React from 'react'
import DropDownEquipes from './Album';


const Equipes = () => {
    return (
        <>
            <DropDownEquipes />
        </>
    )
}

export default Equipes;
